import { render } from "./AppGuestHeader.vue?vue&type=template&id=e6de375a&scoped=true&lang=pug"
import script from "./AppGuestHeader.vue?vue&type=script&lang=js"
export * from "./AppGuestHeader.vue?vue&type=script&lang=js"

import "./AppGuestHeader.vue?vue&type=style&index=0&id=e6de375a&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6de375a"]])

export default __exports__